/**
 * Emit CSS custom properties with --cq- prefix from PlatformConfig theme.
 * @param {Record<string, unknown>} config
 * @returns {string}
 */
export function emitCssVariables(config) {
  const theme = /** @type {Record<string, string>} */ (config.theme || {});
  const branding = /** @type {Record<string, string>} */ (config.branding || {});
  const lines = [":root {"];

  const map = {
    "connected-background": theme.connectedBackground,
    "connected-surface": theme.connectedSurface,
    "connected-surface-soft": theme.connectedSurfaceSoft,
    "connected-surface-muted": theme.connectedSurfaceMuted,
    "primary-text": theme.primaryText,
    "secondary-text": theme.secondaryText,
    "muted-text": theme.mutedText,
    "border-soft": theme.borderSoft,
    "shadow-card": theme.shadowCard,
    "button-primary": theme.buttonPrimary,
    "button-secondary": theme.buttonSecondary,
    "status-blue": theme.statusBlue,
    "status-yellow": theme.statusYellow,
    "status-green": theme.statusGreen,
    "status-red": theme.statusRed,
    "status-neutral": theme.statusNeutral,
    "sidebar-background": theme.sidebarBackground,
    "sidebar-text": theme.sidebarText,
    "sidebar-active-background": theme.sidebarActiveBackground,
    "sidebar-active-text": theme.sidebarActiveText,
    "header-background": theme.headerBackground,
    "module-header-background": theme.moduleHeaderBackground,
    "module-body-background": theme.moduleBodyBackground,
    "card-radius": theme.cardRadius,
    "brand-accent": branding.brandAccent,
    "brand-accent-soft": branding.brandAccentSoft,
    "background-overlay": branding.backgroundOverlay,
    "logo-asset": branding.logoAsset,
    "spacing-scale": theme.spacingScale,
    "connected-header-layout": theme.connectedHeaderLayout,
    "shell-base-theme": config.shellBaseTheme,
  };

  let count = 0;
  for (const [key, value] of Object.entries(map)) {
    if (value !== undefined && value !== null) {
      lines.push(`  --cq-${key}: ${value};`);
      count += 1;
    }
  }

  lines.push("}");
  if (count < 30) {
    throw new Error(`Expected at least 30 --cq- variables, got ${count}`);
  }
  return lines.join("\n");
}
